<template>
  <b-card class="container p-1">
    <h1 class="card-title">Groundwater Information</h1>
    <p>
      Learn more about <a href="https://www2.gov.bc.ca/gov/content/environment/air-land-water/water/groundwater-wells-aquifers/groundwater-wells">groundwater wells in B.C.</a>:
    </p>
      <div>
        <ul>
          <li>Groundwater protection regulation</li>
          <li>Information for property owners</li>
          <li>Information for well drillers and pump installers</li>
          <li><a href="http://www2.gov.bc.ca/gov/content?id=9970743EF6B24B29A888D6AF038715FB" target="_blank">Aquifers and the provincial observation well network</a></li>
        </ul>
      </div>

      <p>
        <a href="http://www2.gov.bc.ca/gov/content/environment/air-land-water/water/water-science-data/water-data-tools" target="_blank">Data and mapping tools</a> are available, which provide detailed information about groundwater, wells, and aquifers.
      </p>

    <div>
    Tools include:
    </div>
    <div>
      <ul>
        <li><a href="http://maps.gov.bc.ca/ess/hm/wrbc/" target="_blank">B.C. Water Resource Atlas</a></li>
        <li><a href="https://maps.gov.bc.ca/ess/hm/imap4m/" target="_blank">iMapBC</a></li>
        <li><a href="https://catalogue.data.gov.bc.ca/dataset?q=groundwater&sort=score+desc%2C+record_publish_date+desc" target="_blank">DataBC datasets</a></li>
      </ul>
    </div>

    <div>
      <p>For assistance on searching for a well, contact FrontCounterBC.</p>

      <div>Phone: 1-877-855-3222</div>
      <div>Email: <a href="mailto:frontcounterbc@gov.bc.ca">frontcounterbc@gov.bc.ca</a></div>
      <div>Or visit any <a href="https://portal.nrs.gov.bc.ca/web/client/locations" target="_blank">FrontCounterBC location</a>.</div>
    </div>

  </b-card>
</template>

<script>
export default {
  name: 'GroundwaterInformation'
}
</script>

<style>

</style>
